export const iconFontAwesomeFilesPhotoFilm = (
	<i className="fa-solid fa-photo-film"></i>
);
